/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  Publication,
  PublicationInterface,
} from "../../contracts/Publication";

const _abi = [
  {
    inputs: [],
    name: "Initialized",
    type: "error",
  },
  {
    inputs: [],
    name: "NonTransferrable",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenDoesNotExist",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "PublicationAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WRITER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "_burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "mintFee",
            type: "uint256",
          },
        ],
        internalType: "struct IPublication.PublicationInfo",
        name: "publication",
        type: "tuple",
      },
    ],
    name: "addPublication",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
    ],
    name: "addWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getPublicationInfo",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "mintFee",
            type: "uint256",
          },
        ],
        internalType: "struct IPublication.PublicationInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mintTimestampOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
    ],
    name: "removeWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "s_publications",
    outputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "mintFee",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "s_tokenCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "publicationId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mintFee",
        type: "uint256",
      },
    ],
    name: "setMintFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenDataOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint96",
            name: "mintTimestamp",
            type: "uint96",
          },
        ],
        internalType: "struct IERC721Time.TokenData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type PublicationConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PublicationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Publication__factory extends ContractFactory {
  constructor(...args: PublicationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Publication> {
    return super.deploy(overrides || {}) as Promise<Publication>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Publication {
    return super.attach(address) as Publication;
  }
  override connect(signer: Signer): Publication__factory {
    return super.connect(signer) as Publication__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PublicationInterface {
    return new utils.Interface(_abi) as PublicationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Publication {
    return new Contract(address, _abi, signerOrProvider) as Publication;
  }
}
